<article class="text-center" style="direction: rtl">
  <div class="row" id="title-part">
    <div class="row">
      <div class="column medium-12">
        <h2 class="title-header">صندوق رشد پایدار</h2>
        <p class="header-description">درآمد ثابت قابل معامله در بورس</p>
        <div style="z-index: -1" class="column medium-12">
          <img
            style="margin-top: -5%; margin-bottom: -20%"
            src="../../assets/images/money-stacks-ladder-2.jpg"
            alt="money-stacks-ladder"
            class="alignnone"
          />
        </div>
        <h3 class="header-description">جایگزین سپرده های بانکی شما</h3>
      </div>

      <div style="margin-top: 3rem" class="column medium-12">
        <div class="column medium-6">
          <p style="margin-bottom: 3rem; font-size: 12pt" class="flex-item">
            <strong>سقف سود سالانه ۲۴ %</strong>
          </p>
        </div>

        <div class="column medium-6">
          <p style="margin-bottom: 3rem; font-size: 12pt" class="flex-item">
            <strong>پرداخت سود ماهانه</strong>
          </p>
        </div>

        <div class="column medium-6">
          <p style="margin-bottom: 3rem; font-size: 12pt" class="flex-item">
            <strong>سود روز شمار</strong>
          </p>
        </div>

        <div class="column medium-6">
          <p style="margin-bottom: 3rem; font-size: 12pt" class="flex-item">
            <strong>نقد شوندگی بالا</strong>
          </p>
        </div>
      </div>

      <div class="column medium-12">
        <div class="column medium-12">
          <h4 class="column medium-12 header-description">
            گروه آبان با سابقه مدیریت ۹۰۰۰ میلیارد تومان دارایی
          </h4>
        </div>

        <div class="colunm medium-12">
          <p style="margin-bottom: 3rem" class="aban-assets-description">
            مدیر صندوق درآمد ثابت کوثر یکم با کسب بازدهی ۲۶.۵۷ درصد در سال ۱۴۰۰
          </p>
        </div>

        <div class="colunm medium-12">
          <p class="aban-assets-description-with-border">
            سرمایه گذاری از طریق سامانه معاملات آنلاین شرکت کارگزاری آبان
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="row div-border">
      <div class="column medium-12">
        <div class="column medium-12">
          <h3 class="box-header">روش سرمایه گذاری در صندوق</h3>
        </div>

        <div class="column medium-12 text-justify">
          <p style="font-size: 12pt"><strong>روش غیر حضوری</strong></p>
          <p style="font-size: 12pt">
            &#9679; ثبت نام و احراز هویت در گارگزاری آبان<br />
            &#9679; ورود به سامانه آنلاین<br />
            &#9679; ثبت دستور خرید در نماد "رشد"<br />
          </p>
        </div>

        <div class="column medium-12 investing-way-buttons">
          <div class="column medium-6">
            <p style="text-align: center">
              <a
                class="wpfs button primary round"
                style="color: #fff"
                target="_blank"
                href="https://ehraz.aban.net/"
                rel="noopener"
                >سامانه احراز هویت</a
              >
            </p>
          </div>

          <div class="column medium-6">
            <p style="text-align: center">
              <a
                class="wpfs button primary round"
                style="color: #fff"
                target="_blank"
                href="https://online.aban.net/Login"
                rel="noopener"
                >سامانه معاملات آنلاین</a
              >
            </p>
          </div>
        </div>

        <div class="column medium-12">
          <div class="text-justify">
            <p style="font-size: 12pt" class=""><strong>روش حضوری</strong></p>

            <p style="font-size: 12pt">
              &#9679; ثبت نام در کارگزاری آبان<br />
              &#9679; مراجعه به کارگزاری جهت احراز هویت با اصل شناسنامه و کارت
              ملی<br />
              &#9679; ثبت دستور حضوری خرید در نماد "رشد"<br />
            </p>
          </div>
          <div class="column medium-12 text-right">
            <p>
              <a
                class="wpfs button primary round"
                style="color: #fff"
                target="_blank"
                href="https://ehraz.aban.net/"
                rel="noopener"
                >سامانه احراز هویت</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="row div-border">
      <div class="column medium-12">
        <div class="column medium-12">
          <p class="text-center box-header">اطلاعات تکمیلی</p>
        </div>
        <div class="column medium-12">
          <p style="font-size: 12pt" class="">
            <strong>صندوق های قابل معامله چیست</strong>
          </p>
          <p class="text-justify">
            واحد صندوق های قابل معامله (ETF) در بازار سرمایه داد و ستد می‌شود و
            قیمت آنها از طریق مکانیزم عرضه و تقاضا، با قیمتی نزدیک به NAV تعیین
            می‌گردد.
          </p>
        </div>
        <div class="column medium-12 text-right">
          <p>
            <a
              class="wpfs button primary round"
              style="color: #fff"
              target="_blank"
              href="/training/etf"
              rel="noopener"
              >آشنایی با صندوق های ETF</a
            >
          </p>
        </div>
        <div class="column medium-12">
          <p style="font-size: 12pt" class="">
            <strong>معاملات بر خط چیست</strong>
          </p>
          <p class="text-justify">
            با استفاده از کامپیوتر و یا تلفن همراه با اتصال به سامانه معاملات بر
            خط، خرید و فروش در بورس اوراق بهادار تهران ، بدون واسطه و در ساعات
            معاملات امکان پذیر می‌باشد.
          </p>
        </div>
        <div class="column medium-12 text-right">
          <p>
            <a
              class="wpfs button primary round"
              style="color: #fff"
              target="_blank"
              href="/services/online-plus"
              rel="noopener"
              >آشنایی با معاملات برخط</a
            >
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="column medium-12">
        <p style="margin: 2rem 0 7rem 0" class="text-justify">
          جهت کسب اطلاع بیشتر میتوانید با سامانه رشد پایدار به نشانی
          <a href="https://rpfund.ir/">www.rpfund.ir</a> مراجعه نمایید و یا از
          طریق شماره ۸۵۵۱۰ - ۰۲۱ با امور مشتریان تماس بگیرید.
        </p>
      </div>
    </div>
  </div>
</article>
